/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'prettyPrintDescription',
    standalone: false
})
export class PrettyPrintDescriptionPipe implements PipeTransform {

    transform(reference: { code: string, description: string }): string {
        return reference ? `${reference.code} - ${reference.description}` : null;
    }

}
